// core
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// form validation
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"

//constants
import { SUBSCRIPTION_FORM } from "../constants/subscriptionFormLocation";
import usaStatesList from "../assets/resources/usa-states-list.json"

//data-layer
import { setSubscriptionSignUpEvent } from "../assets/js/data-layer";
import { useConsent } from '../components/ConsentContext'

// icons
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { useCookies } from 'react-cookie'

const NewsLetterSignUp = ({ subscriptionFormTitle, subscriptionFormCopy, subscriptionFormName, OGSourceId }) => {
    const [showForm, setShowForm] = useState(true)
    const [failedMsg, setFailedMsg] = useState(false)
    const [birthDayValue, setBirthDayValue] = useState("")
    const consentAccepted = useConsent()
    const [segmentID, setSegmentID] = useState("")
    const OPTIN_URL = process.env.GATSBY_OPTIN_URL
    const [cookies, setCookie] = useCookies()
    // const AC_OPTIN_URL = process.env.GATSBY_AC_OPTIN_URL

    // birthDay Field Validation
    // consider improving checkValue() to limit min years
    const checkValue = (str, max) => {
        if (str.charAt(0) !== '0' || str === '00') {
            let num = parseInt(str)
            if (isNaN(num) || num <= 0 || num > max) num = 1
            str = num > parseInt(max.toString().charAt(0)) && num.toString().length === 1 ? '0' + num : num.toString()
        }
        return str
    }

    const checkYear = (str, max) => {
        if(str.length === 4) {
            return str > max || str.charAt(0) === "0" ? max : str;
        }
        return str;
    }

    const handleBirthDateChange = (e) => {
        let input = e.target.value
        if (/\D\/$/.test(input)) input = input.substr(0, input.length - 3)
        let values = input.split('/').map(function(v) {
            return v.replace(/\D/g, '')
        })

        if (values[0]) values[0] = checkValue(values[0], 12)
        if (values[1]) values[1] = checkValue(values[1], 31)
        if (values[2]) values[2] = checkYear(values[2], new Date().getFullYear())
        let output = values.map(function(v, i) {
            return v.length === 2 && i < 2 ? v + '/' : v
        })
        setBirthDayValue(output.join('').substr(0, 10))
    }

    const checkLegalAge = (value) => {
        const bdayDate = new Date(value);
        const today = new Date();
        const age = Math.floor((today-bdayDate) / (365.25 * 24 * 60 * 60 * 1000));
        return age >= 21;
    }

    useEffect(() => {
        if (typeof window !== "undefined") {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            let ajs_anonymous_id = localStorage.getItem("ajs_anonymous_id")?.replace(/"/g, "") || ''

            if (ajs_anonymous_id && consentAccepted) {
                // console.log('ajs_anonymous_id  ' , ajs_anonymous_id)
                setSegmentID(ajs_anonymous_id)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consentAccepted])

    //method checking the date is valid
    const checkIsDateValid = (dateString) => {
        var parts = dateString.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);

        // Check the ranges of month and year
        if (year < 1000 || year > 3000 || month === 0 || month > 12) {
            return false;
        }

        // Check the number of days in the month
        var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month === 2 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) {
            // Leap year
            if (day > 29) {
                return false;
            }
        } else {
            if (day > monthLength[month - 1]) {
                return false;
            }
        }

        return true;
    }

    // script Nexxen on every email signup
    const addNexxenScript = () => {
        const script = document.createElement("script");
        script.id = "Beacon"
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `turn_beacon_price = ""; turn_client_track_id = ""; !function(e,n){void 0!==e.__cmp&&e.__cmp("getVendorConsents",[23],function(e){void 0!==e&&e.vendorConsents[23]&&function(e){var n=o.createElement("script");n.async=!0,n.src=e;var t=o.getElementsByTagName("script")[0];t.parentNode.insertBefore(n,t)}("//r.turn.com/server/beacon_call.js?b2=yK6Ur1fdDLUo067x8v4GfgBNPkztpCquG2rpAFkbHyS8F3UH7HjqzSmVuHz4eBxvX_M9wCiIOAB_Giv3abkTfQ")})}(window,document); !function(e,t,r){void 0!==e.__tcfapi&&e.__tcfapi("getTCData",2,(e,t)=>{var n=function(e,t){var r=e.createElement("script");r.async=!0,r.src=t;var n=e.getElementsByTagName("script")[0];n.parentNode.insertBefore(r,n)}; if(t){if(void 0!==e.gdprApplies&&e.gdprApplies){var i=e.vendor.consents,s=e.vendor.legitimateInterests,o=e.publisher.restrictions,p=e.purpose.consents,c=e.purpose.legitimateInterests; if(i[23]&&s[23])if(0!==Object.keys(o).length){if(1===o[7][23]&&p[7]||1===o[9][23]&&c[9]||1===o[10][23]&&c[10])return void n(r+"&gdpr=1&gdpr_consent="+e.tcString)} else if((p[1]||p[3])&&(c[7]||c[9]||c[10]))return void n(r+"&gdpr=1&gdpr_consent="+e.tcString)}n(r+"&gdpr=0&gdpr_consent=/"+e.tcString)} else console.error("Unable to retrieve transparency and consent data"),n(r+"&gdpr=0&gdpr_consent=/"+e.tcString)},[23])}(window,document,'//r.turn.com/server/beacon_call.js?b2=yK6Ur1fdDLUo067x8v4GfgBNPkztpCquG2rpAFkbHyS8F3UH7HjqzSmVuHz4eBxvX_M9wCiIOAB_Giv3abkTfQ'); !function(e,a){var t=function(e){var t=a.createElement("script");t.async=!0,t.src=e;var r=a.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)};void 0===e.__uspapi?t("//r.turn.com/server/beacon_call.js?b2=yK6Ur1fdDLUo067x8v4GfgBNPkztpCquG2rpAFkbHyS8F3UH7HjqzSmVuHz4eBxvX_M9wCiIOAB_Giv3abkTfQ"):e.__uspapi("getUSPData",1,(e,a)=>{var r="//r.turn.com/server/beacon_call.js?b2=yK6Ur1fdDLUo067x8v4GfgBNPkztpCquG2rpAFkbHyS8F3UH7HjqzSmVuHz4eBxvX_M9wCiIOAB_Giv3abkTfQ";a&&(r="//r.turn.com/server/beacon_call.js?b2=yK6Ur1fdDLUo067x8v4GfgBNPkztpCquG2rpAFkbHyS8F3UH7HjqzSmVuHz4eBxvX_M9wCiIOAB_Giv3abkTfQ&us_privacy="+e.uspString),t(r)})}(window,document); `
        document.head.appendChild(script)
    }


    const createRedditScript=()=>{
        try {
            window.rdt('track', 'SignUp',{
              "currency": "USD",
              "transactionId":"12345678",
              "itemCount": 1,
              "value": 100,
              "products": {
                "id": "product id 1",
                "name": "product name 1",
                "category": "product category 1" },
            } );
        } catch (err) {
            console.log('# Error on reddit trigger:');
            console.log(err);
        }
    }

    return (
        <>
        {(showForm) ?
        <>
        {/* Form */}
        <Formik

            initialValues={ // initial form values
                {
                    firstname: "",
                    lastname: "",
                    email: "",
                    birthdate: "",
                    state: "",
                    agreeCheckbox: false
                }
            }

            validationSchema={Yup.object({ // validate form
                firstname: Yup.string().required("This field is required."),
                lastname: Yup.string().required("This field is required."),
                email: Yup.string().email("Invalid email address").required("This field is required."),
                birthdate: Yup.date().required("Please enter your birthday.")
                    .test("birthdate", "Please provide a valid birthday MM/DD/YYYY", () => { return !(birthDayValue?.length < 10) })
                    .test("birthdate", "Please input a valid date of birth.", () => {
                        return checkIsDateValid(birthDayValue);
                    })
                    .test("birthdate", "To subscribe, you must be of legal drinking age", (value) => {
                    return checkLegalAge(value);
                }),
                agreeCheckbox: Yup.bool()
                    .oneOf([true], 'This field is required.'),
            })}

            onSubmit={(values, { setSubmitting, resetForm }) => {
                setSubmitting(false)

                let today = new Date()
                today.setDate(today.getDate() + 365)
                let ayearFromCurrentDate = today
                setCookie('wc_subscriber', true, { expires: ayearFromCurrentDate, path: '/' });

                // OG
                const dataOG = {
                    FirstName: values.firstname.trim(),
                    LastName: values.lastname.trim(),
                    Email: values.email.trim(),
                    BirthDate: values.birthdate.trim(),
                    SourceId: OGSourceId,
                    Brand: "WCB", // White Claw Brand
                    Country: values.state !== ""  ? "US" : "",
                    SourceCountry: "US",
                    State: values.state.trim(),
                    DpMktEmailStatus: true, // This is hard coded
                    SegmentId: segmentID
                }

                const subscribeOptInKetchNewsLetter = (dataObj) => {
                    return axios.post(OPTIN_URL, dataObj)
                }

                Promise.all([subscribeOptInKetchNewsLetter(dataOG)]).then(function (results) {

                    const optInKetchResponse = results[0];

                    if (optInKetchResponse.data.success !== false) {
                        const marketingCheckbox=values.agreeCheckbox
                        // data layer
                        setSubscriptionSignUpEvent({location:subscriptionFormName,formName:'shore_club',marketingCheckbox}, consentAccepted)

                        //Meta and snap pixel signup event
                        const isBrowser = typeof window !== "undefined"
                        if (isBrowser)
                        {
                          if(window.fbq)
                              window.fbq('track', 'Contact');
                          if(window.snaptr)
                              window.snaptr('track', 'SIGN_UP');
                          addNexxenScript();
                        }
                        //calling reddit script
                        if (window.rdt && typeof window.rdt === 'function') {
                            createRedditScript()
                        }

                        // Update the form to Thank you message
                        setShowForm(false)
                    } else {
                        setShowForm(false)
                        setFailedMsg(true)
                    }
                }).catch(function(err) {
                    console.log(err)
                    setShowForm(false)
                    setFailedMsg(true)
                })

                // Reset form
                resetForm()
            }}

            >

            {({ values, errors, submitCount }) => {
                // console.log('errors ', errors)
                return (
                <div className={"subscription-form mx-auto " + (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER ? 'subscription-form--footer' : '')}>

                    {(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                    ?
                    <>
                    <h1>{subscriptionFormTitle}</h1>
                    <p dangerouslySetInnerHTML={{ __html: subscriptionFormCopy }} />
                    </>
                    :
                    (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)
                    ?
                    <>
                    <h1 className="subscription-form-title text-center text-bold">{subscriptionFormTitle}</h1>
                    <p dangerouslySetInnerHTML={{ __html: subscriptionFormCopy }} />
                    </>
                    :
                    <>
                    <h1 className="text-center mb-0">{subscriptionFormTitle}</h1>
                    <p className="text-center">{subscriptionFormCopy}</p>
                    </>
                    }


                    <div className={(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                        ? ""
                        : (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)
                        ? "newsletter-footer-form-wrapper"
                        : "_form_114 subscribe-form-wrapper"}
                    >

                        <Form className={(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                            ? "newsletter-form newsletter-popup-form"
                            : (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER || subscriptionFormName === SUBSCRIPTION_FORM.OUR_STORY)
                            ? "newsletter-footer-form"
                            : "subscribe-form subscribe-page-form"}
                            autoComplete="off"
                        >

                            {/* First name */}
                            <div className="position-relative">
                                <Field type="text" name="firstname" className={"w-100 " + (subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE
                                ? 'newsletter-input-subscribe'
                                : 'newsletter-input')}
                                id="firstname"
                                placeholder="First Name*"
                                />

                                {(submitCount > 0 && errors.firstname !== "") ?
                                <span className={"input-error " + (!errors.firstname ? 'd-none' : '')}>{errors.firstname}</span>
                                :
                                null
                                }
                            </div>

                            {/* Last name */}
                            <div className="position-relative">
                                <Field type="text" name="lastname" className={"w-100 " + (subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE
                                ? 'newsletter-input-subscribe'
                                : 'newsletter-input')}
                                id="lastname"
                                placeholder="Last Name*"
                                />

                                {(submitCount > 0 && errors.lastname !== "") ?
                                <span className={"input-error " + (!errors.lastname ? 'd-none' : '')}>{errors.lastname}</span>
                                :
                                null
                                }
                            </div>

                            {/* Email */}
                            <div className="position-relative">
                                <Field type="text" name="email" className={"w-100 " + (subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE
                                ? 'newsletter-input-subscribe'
                                : 'newsletter-input')}
                                id="email"
                                placeholder="Email*"
                                />

                                {(submitCount > 0 && errors.email !== "") ?
                                <span className={"input-error " + (!errors.email ? 'd-none' : '')}>{errors.email}</span>
                                :
                                null
                                }
                            </div>

                            {/* DOB */}
                            <div className="position-relative">
                                <Field type="text" name="birthdate" className={"w-100 " + (subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE
                                    ? 'newsletter-input-subscribe'
                                    : 'newsletter-input')}
                                       id="birthdate"
                                       placeholder="Date of Birth*"
                                       onChange={handleBirthDateChange}
                                       onFocus={(e)=> e.target.placeholder = 'MM/DD/YYYY'}
                                       onBlur={(e)=> e.target.placeholder = 'Date of Birth*'}
                                       value={(values.birthdate = birthDayValue)}
                                />

                                {(submitCount > 0 && errors.birthdate !== "") ?
                                    <span className={"input-error " + (!errors.birthdate ? 'd-none' : '')}>{errors.birthdate}</span>
                                    :
                                    null
                                }
                            </div>

                            {/* State */}
                            <div className='position-relative'>
                                <Field
                                    className={"w-100 " + (subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE
                                    ? 'newsletter-input-subscribe'
                                    : 'newsletter-input')}
                                    as="select"
                                    name="state"
                                    placeholder="State"
                                >
                                    <option value="">State</option>
                                    {usaStatesList && Object.keys(usaStatesList).map((state) =>
                                        <option key={state} value={state}>{state}</option>
                                    )}
                                </Field>
                                <FontAwesomeIcon icon={faChevronDown} className="fa-solid arrow-icon" />
                                { submitCount > 0 && errors.state && <span className="input-error">{errors.state}</span> }
                            </div>

                            {/* Agree Checkbox */}
                            <div className="agree-checkbox position-relative">
                                <label className="agree-checkbox__label">
                                    <Field id="agreeCheckbox" type="checkbox" name="agreeCheckbox" />
                                    &nbsp;
                                    <span className="agree-checkbox__checkmark"></span>
                                    &nbsp;
                                    <span className="agree-checkbox__copy">
                                        Please tick here to confirm that you have read and acknowledge our <a href="/privacy" target='_blank' title="Privacy Policy"><u>Privacy Policy</u></a> and <a href="/privacy#notice-financial" target='_blank'><u>Notice of Financial Incentive</u></a>. You can unsubscribe at anytime.
                                    </span>
                                </label>
                                { submitCount > 0 && errors.agreeCheckbox && <span className="input-error">{errors.agreeCheckbox}</span> }
                            </div>

                            {/* Submit button */}
                            <input
                            className={(subscriptionFormName === SUBSCRIPTION_FORM.SUBSCRIBE_PAGE)
                            ? "newsletter-input-submit subscribe-page"
                            : "newsletter-input-submit"}
                            type="submit" value="JOIN US"
                            />
                        </Form>
                    </div>
                </div>
                )
            }}

        </Formik>
        {/* Eof form */}

        </>
        :
        <>
        {(failedMsg)
        ?
            <>
            <div className="subscription-form text-center mx-auto">
                {(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                ?
                null
                :
                (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)
                ?
                <div id="subscription-form-title" className="subscription-form-title text-center text-bold">Join White Claw Shore Club</div>
                :
                <div id="subscription-form-title" className="subscription-form-title subscription-page-form-title text-center text-bold">Join White Claw Shore Club</div>
                }
                <div className="newsletter-footer-form-wrapper">
                    <div className="newsletter-footer-form">
                        {(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                        ?
                        <div className="text-white text-center thank-you">It seems that our server is not responding. <br /> Please try again later!</div>
                        :
                        (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)
                        ?
                        <div className="text-white text-center">It seems that our server is not responding. <br /> Please try again later!</div>
                        :
                        <div className="text-center">It seems that our server is not responding. <br /> Please try again later!</div>
                        }
                    </div>
                </div>
            </div>
            </>
        :
            <>
            <div className="subscription-form text-center mx-auto">
                {(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                ?
                null
                :
                (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)
                ?
                <div id="subscription-form-title" className="subscription-form-title text-center text-bold">You’re In!</div>
                :
                <div id="subscription-form-title" className="subscription-form-title subscription-page-form-title text-center text-bold">You’re In!</div>
                }
                <div className="newsletter-footer-form-wrapper">
                    <div className="newsletter-footer-form">
                        {(subscriptionFormName === SUBSCRIPTION_FORM.POP_UP)
                        ?
                        <div className="text-white text-center thank-you">Our crew just got more epic. Keep an eye on your inbox and get ready to start Grabbing Life By The Claw™.</div>
                        :
                        (subscriptionFormName === SUBSCRIPTION_FORM.FOOTER)

                        ?
                        <div className="text-white text-center">Our crew just got more epic. Keep an eye on your inbox and get ready to start Grabbing Life By The Claw™.</div>
                        :
                        <div className="text-center">Our crew just got more epic. Keep an eye on your inbox and get ready to start Grabbing Life By The Claw™.</div>
                        }
                        {/*
                        <div className={"text-white text-center " + (subscriptionFormName === SUBSCRIPTION_FORM.POP_UP ? 'thank-you' : '')}>Thanks for signing up for the Wave!</div>
                        */}
                    </div>
                </div>
            </div>
            </>
        }
        </>
        }
        </>
    )
}

export default NewsLetterSignUp